import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
    BarChart, Bar, PieChart, Pie, Cell, Legend,
} from "recharts";

const COLORS = ["#1D6DE6", "#5FBB2E", "#F97316", "#14B8A6", "#94A3B8", "#A855F7"];

const chartStyles = {
    tooltipStyle: {
        backgroundColor: "hsl(var(--card))",
        border: "1px solid hsl(var(--border))",
        borderRadius: 0,
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: 12,
    },
};

export function TimeSeriesChart({ data, dataKey = "count", label = "Clicks" }) {
    const safe = data && data.length ? data : [{ date: "—", count: 0 }];
    return (
        <div className="h-[280px] w-full" data-testid="timeseries-chart">
            <ResponsiveContainer width="100%" height="100%">
                <LineChart data={safe} margin={{ top: 12, right: 12, left: -18, bottom: 0 }}>
                    <CartesianGrid stroke="hsl(var(--border))" strokeDasharray="3 3" vertical={false} />
                    <XAxis dataKey="date" tick={{ fontFamily: "JetBrains Mono", fontSize: 11, fill: "hsl(var(--muted-foreground))" }} axisLine={false} tickLine={false} />
                    <YAxis allowDecimals={false} tick={{ fontFamily: "JetBrains Mono", fontSize: 11, fill: "hsl(var(--muted-foreground))" }} axisLine={false} tickLine={false} />
                    <Tooltip contentStyle={chartStyles.tooltipStyle} />
                    <Line
                        type="monotone"
                        dataKey={dataKey}
                        name={label}
                        stroke={COLORS[0]}
                        strokeWidth={2.5}
                        dot={{ r: 3, fill: COLORS[0] }}
                        activeDot={{ r: 5 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}

export function BreakdownBar({ data, title, testId }) {
    const safe = (data || []).slice(0, 8);
    return (
        <div className="border border-border bg-card p-5" data-testid={testId}>
            <div className="mb-3 text-xs font-semibold uppercase tracking-widest text-muted-foreground">{title}</div>
            {safe.length === 0 ? (
                <div className="py-8 text-center text-sm text-muted-foreground">No data yet</div>
            ) : (
                <div className="h-[220px]">
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={safe} layout="vertical" margin={{ top: 4, right: 12, left: 8, bottom: 4 }}>
                            <XAxis type="number" hide />
                            <YAxis
                                dataKey="label"
                                type="category"
                                width={110}
                                tick={{ fontFamily: "JetBrains Mono", fontSize: 11, fill: "hsl(var(--foreground))" }}
                                axisLine={false}
                                tickLine={false}
                            />
                            <Tooltip contentStyle={chartStyles.tooltipStyle} />
                            <Bar dataKey="count" fill={COLORS[1]} radius={0} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            )}
        </div>
    );
}

export function DonutBreakdown({ data, title, testId }) {
    const safe = (data || []).slice(0, 6);
    return (
        <div className="border border-border bg-card p-5" data-testid={testId}>
            <div className="mb-3 text-xs font-semibold uppercase tracking-widest text-muted-foreground">{title}</div>
            {safe.length === 0 ? (
                <div className="py-8 text-center text-sm text-muted-foreground">No data yet</div>
            ) : (
                <div className="h-[220px]">
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie data={safe} dataKey="count" nameKey="label" innerRadius={45} outerRadius={80} paddingAngle={2}>
                                {safe.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                            </Pie>
                            <Tooltip contentStyle={chartStyles.tooltipStyle} />
                            <Legend
                                verticalAlign="bottom"
                                iconSize={8}
                                wrapperStyle={{ fontFamily: "JetBrains Mono", fontSize: 11 }}
                            />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            )}
        </div>
    );
}
